export default {
    gerCurrentTime(date = new Date()) {
        let yy = date.getFullYear();
        let mm = date.getMonth() + 1;
        let dd = date.getDate();
        let hh = date.getHours();
        let mf =
            date.getMinutes() < 10 ?
            "0" + date.getMinutes() :
            date.getMinutes();
        let time = yy + "年" + mm + "月" + dd + "日" + " " + hh + ":" + mf
        return time
    }
}